import { useQuery } from '@tanstack/react-query';
import {
  fetchInventory,
  fetchRates,
  type InventoryQuery,
  type RatesQuery,
} from '@/services/api/availability.api';

export function useInventory(query: InventoryQuery) {
  return useQuery({
    queryKey: ['availability', 'inventory', query],
    queryFn: () => fetchInventory(query),
    staleTime: 30_000,
  });
}

export function useAvailabilityRates(query: RatesQuery) {
  return useQuery({
    queryKey: ['availability', 'rates', query],
    queryFn: () => fetchRates(query),
    staleTime: 30_000,
  });
}
